import { render } from "./StayAhead.vue?vue&type=template&id=d3836420&scoped=true"
import script from "./StayAhead.vue?vue&type=script&lang=js"
export * from "./StayAhead.vue?vue&type=script&lang=js"

import "./StayAhead.vue?vue&type=style&index=0&id=d3836420&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3836420"]])

export default __exports__